import { Injectable } from "@angular/core";
import { CanDeactivate, ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { ICanComponentDeactivate } from "../interfaces/icancomponentdeactivate";
import { Observable } from "rxjs";


@Injectable()
export class PendingChangesGuardService implements CanDeactivate<ICanComponentDeactivate> {
    canDeactivate(component: ICanComponentDeactivate,
        currentRoute: ActivatedRouteSnapshot,
        currentState: RouterStateSnapshot,
        nextState?: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
        component.navigatingTo = nextState ? nextState.url : "";
        return component.canDeactivate ? component.canDeactivate() : true;
    }
}

